import { render, staticRenderFns } from "./privacyyyjd.vue?vue&type=template&id=268b8fb6&scoped=true"
import script from "./privacyyyjd.vue?vue&type=script&lang=js"
export * from "./privacyyyjd.vue?vue&type=script&lang=js"
import style0 from "./privacyyyjd.vue?vue&type=style&index=0&id=268b8fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b8fb6",
  null
  
)

export default component.exports